import { render, staticRenderFns } from "./DhmeAssemblyHallDashboardManualTrestles.vue?vue&type=template&id=04e3fc54&scoped=true"
import script from "./DhmeAssemblyHallDashboardManualTrestles.vue?vue&type=script&lang=js"
export * from "./DhmeAssemblyHallDashboardManualTrestles.vue?vue&type=script&lang=js"
import style0 from "./DhmeAssemblyHallDashboardManualTrestles.vue?vue&type=style&index=0&id=04e3fc54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e3fc54",
  null
  
)

export default component.exports